import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=973b0cca&scoped=true"
import script from "./DialogConfirm.vue?vue&type=script&lang=ts"
export * from "./DialogConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973b0cca",
  null
  
)

export default component.exports